/**
 * Converts a base64-encoded string into a `Blob` object with the specified blob options (e.g. MIME type).
 */
export const base64toBlob = (encoded: string, options: BlobPropertyBag) => {
    const byteCharacters = atob(encoded);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], options);
};
